import { INITIALIZE, SEND_FINISHED, SEND_PARSING_ERRORS } from './constants';

import { Record } from 'immutable';

/*
  0 = not started
  1 = started
  2 = error
  3 = success
 */
const LogStatus = Record({
  parsingErrors: 0,
  connectionError: 0,
});

const InitialState = Record({
  fields: new (Record({
    parsingErrors: true,
  }))(),
  showStatus: false,
  sending: false,
  logStatus: new LogStatus(),
});
const initialState = new InitialState();

export default function diagnosticsReducer(
  state = initialState,
  action = undefined,
) {
  switch (action.type) {
    case `${SEND_PARSING_ERRORS}_START`: {
      return state
        .set('logStatus', new LogStatus())
        .set('sending', true)
        .set('showStatus', true)
        .setIn(['logStatus', 'parsingErrors'], 1);
    }
    case `${SEND_PARSING_ERRORS}_SUCCESS`:
      return state.setIn(['logStatus', 'parsingErrors'], 3);
    case `${SEND_PARSING_ERRORS}_ERROR`:
      return state.setIn(['logStatus', 'parsingErrors'], 2);
    case INITIALIZE:
      return state
        .set('logStatus', new LogStatus())
        .set('sending', false)
        .set('showStatus', false);
    case SEND_FINISHED:
      return state.set('sending', false);
    default:
      return state;
  }
}
